import React,{ useState,useEffect } from 'react';
import { Box } from '@mui/material';
import BasicButton from '../buttons/basicButton';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom'
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import PhonelinkIcon from '@mui/icons-material/Phonelink';

const ArticleBox = styled(Box)`
        position: relative;
        display: flex;
        flex-direction:column;

        & .title {
            display: flex;
            flex-direction: row;
            color:black;
            text-align:left;
            white-space: pre-line;
        }

        & .line {
            padding: 0 12px;
            border-left:2px solid var(--pxft-primary);
        }

        & .content {
            padding:40px 0;
            line-height:1.3;
            white-space: pre-line;
        }

        & .btn-container {
            position: absolute;
            bottom: 0;
            right:0;
            width: 130px;
            height:40;
        }

        & .platform-icons {
            display: flex;
            align-items: center;
            gap: 16px;
            padding: 0 0 20px 0;
            color: var(--pxft-darkgrey);
        }

        & .platform-icon {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 6px;
            min-width: 54px;
            font-size: 0.72rem;
            text-align: center;
            line-height: 1.1;
        }

        & .platform-icon svg {
            color: var(--pxft-primary);
            font-size: 24px;
        }
	`;

const platformIconMap = {
    inapp: SmartphoneIcon,
    web: LaptopMacIcon,
    mobileWeb: PhonelinkIcon,
};

const ArticleCardB = ({long=true,title='',button=true,btnText='Learn More',link='',list=[],platforms=[]}) =>{
    const [lineHeight, setLineHeight] = useState('130px');
    const getHeightofTitle =(element) =>{
        let h1height = element.getAttribute('height');
        setLineHeight(h1height);
    }
    const bulletStyle={
        background:`url('/images/bullet-symbol.svg') no-repeat left center`,
        backgroundSize: '8px'
    }

    useEffect(()=>{
        let element = document.getElementsByTagName("h1")[0];
        getHeightofTitle(element);
    },[])
    
    return (
        <ArticleBox sx={{py:{lg:6,xs:2},px:{lg:3,xs:1},width:'250px',height:long?{xs:'350px',sm:'400px',md:'450px'}:{},pb:platforms.length && button ? 8 : undefined}}>
            <Box className='title'>
                <div className='line' style={{'height':lineHeight}}></div>
                <h1>{title}</h1>
            </Box>
            <div style={{padding:'40px 0'}}>
            {
                list.map((li,i)=>
                <p className='row-list' style={bulletStyle} key={i}>{li}</p>
                )
            }
            </div>
            {platforms.length > 0 ? 
            <div className='platform-icons'>
                {platforms.map((platform) => {
                    const Icon = platformIconMap[platform.value] || SmartphoneIcon;

                    return (
                        <div className='platform-icon' key={platform.value}>
                            <Icon />
                            <span>{platform.label}</span>
                        </div>
                    );
                })}
            </div>:''}
            {button? 
            <div className='btn-container'>
                <Link to={'/'+link}><BasicButton content={btnText}/></Link>
            </div>:''}
        </ArticleBox>
    );
}

export default ArticleCardB;
